import {ActionIcon} from '@mantine/core';
import {AiOutlineUnorderedList} from 'react-icons/ai';
import {useEffect, useState} from 'react';
import {ActivityEventsDrawer} from '../drawers/ActivityEventsDrawer';
import {getVerbosityLevel} from '../../sign-in-profiles/services/SignInProfilesService';
import {VerbosityLevel} from '../../sign-in-profiles/types';

export const EventsButton = () => {
    const [opened, setOpened] = useState(false);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        getVerbosityLevel().then(verbosity => {
            setShowButton(verbosity === VerbosityLevel.HIGH);
        });
    }, []);

    if (!showButton) return null;

    return (
        <>
            <ActionIcon
                variant="subtle"
                size="lg"
                onClick={() => setOpened(true)}
                aria-label="Events"
            >
                <AiOutlineUnorderedList size={20}/>
            </ActionIcon>
            <ActivityEventsDrawer opened={opened} onClose={() => setOpened(false)}/>
        </>
    );
};
